import { uniq } from 'lodash-es';

// eslint-disable-next-line import/prefer-default-export
export const isAppsChanged = (prev, next) => {
  if (prev.length !== next.length) return true;

  const prevRefNos = prev.map(({ ref_no }) => `${ref_no}`);
  const nextRefNos = next.map(({ ref_no }) => `${ref_no}`);

  return uniq(prevRefNos.concat(nextRefNos)).length !== prevRefNos.length;
};
